import {
	Button,
	Dialog,
	DialogSurface,
	DialogBody,
	DialogTitle,
	DialogContent,
	DialogActions,
	Input,
	Label,
	Spinner,
} from '@fluentui/react-components';
import React, { useState } from "react";

export interface INewFolderDialogProps {
	showNewFolderDialog: boolean;
	showCreatingSpinner: boolean;
	onItemsUpdated: () => void;
	createNewFolder: (newName: string) => void;
	closeNewFolderModal: () => void;
}

export const NewFolderDialog: React.FunctionComponent<INewFolderDialogProps> = (props: INewFolderDialogProps) => {
	const [newFolderName, setNewFolderName] = useState<string>("");

	return <Dialog open={props.showNewFolderDialog}>
		<DialogSurface>
			{!props.showCreatingSpinner && (
				<DialogBody className="kt-ui-app dialog-content">
					<DialogTitle>
						New Folder
					</DialogTitle>
					<DialogContent>
						<Label htmlFor="newFolderName">Folder name:</Label>
						<Input
							placeholder="Folder name"
							id="newFolderName"
							aria-label="newFolderName"
							type="text"
							name="newFolderName"
							value={newFolderName}
							onChange={e => setNewFolderName(e.target.value)}
						/>
					</DialogContent>
					<DialogActions>
						<Button appearance="primary" onClick={() => props.createNewFolder(newFolderName)}>
							Create
						</Button>
						<Button appearance="secondary" onClick={() => props.closeNewFolderModal()}>
							Cancel
						</Button>
					</DialogActions>
				</DialogBody>
			)}
			{props.showCreatingSpinner && (
				<>
					<Spinner label="Creating folder..." />
				</>
			)}
		</DialogSurface>
	</Dialog>;
}
